import useTranslation from '../../customHooks/useTranslation';
import Photo from '../../assets/SelfPhoto.webp';
import { GITHUB_URL, LINKEDIN_URL } from '../../config/site';
import { Sheet, SheetHeading } from './Sheet';

// Crop marks around a placed photograph, as on a print sheet.
export function CropMarks() {
	const mark = 'absolute h-5 w-5 border-ink-soft';
	return (
		<span aria-hidden='true'>
			<span className={`${mark} -left-3 -top-3 border-l border-t`} />
			<span className={`${mark} -right-3 -top-3 border-r border-t`} />
			<span className={`${mark} -bottom-3 -left-3 border-b border-l`} />
			<span className={`${mark} -bottom-3 -right-3 border-b border-r`} />
		</span>
	);
}

export default function About() {
	const t = useTranslation();
	const a = t.about;

	return (
		<Sheet id='about' code='A-401' title={t.nav.sheets.about} className='drafting-grid'>
			<div className='mx-auto grid max-w-[1320px] items-start gap-x-12 gap-y-14 px-4 py-20 sm:px-8 lg:grid-cols-12 lg:py-28'>
				<figure className='mx-auto w-full max-w-[360px] lg:col-span-4 lg:mx-0'>
					<div className='relative'>
						<CropMarks />
						<img src={Photo} alt={a.photoAlt} width={720} height={720} loading='lazy' decoding='async' className='aspect-square w-full object-cover grayscale-15' />
					</div>
					<figcaption className='lettering mt-5 text-label text-ink-faint'>{a.photoCaption}</figcaption>
				</figure>

				<div className='lg:col-span-7 lg:col-start-6'>
					<SheetHeading id='about'>{a.heading}</SheetHeading>
					<div className='mt-6 space-y-4 text-lg leading-relaxed text-ink-soft'>
						{a.paragraphs.map((p, i) => (
							<p key={i} className={`max-w-[64ch] ${i === 0 ? 'text-ink' : ''}`}>
								{p}
							</p>
						))}
					</div>

					<dl className='mt-10 grid border-l border-t border-ink-line sm:grid-cols-2'>
						{a.facts.map(f => (
							<div key={f.label} className='border-b border-r border-ink-line px-4 py-3'>
								<dt className='lettering text-[0.66rem] text-ink-faint'>{f.label}</dt>
								<dd className='mt-1 font-semibold text-ink'>{f.value}</dd>
							</div>
						))}
					</dl>

					<p className='mt-8 flex flex-wrap gap-3'>
						<a href={LINKEDIN_URL} target='_blank' rel='noopener noreferrer' className='btn-line'>
							<svg viewBox='0 0 24 24' className='h-4 w-4' aria-hidden='true'>
								<path fill='currentColor' d='M4.98 3.5a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5ZM3 9.75h4v11H3v-11Zm6.5 0h3.8v1.5h.06c.53-1 1.83-2.06 3.77-2.06 4.03 0 4.77 2.65 4.77 6.1v5.46h-4v-4.84c0-1.16-.02-2.64-1.61-2.64-1.62 0-1.86 1.26-1.86 2.56v4.92h-4v-11Z' />
							</svg>
							LinkedIn
						</a>
						<a href={GITHUB_URL} target='_blank' rel='noopener noreferrer' className='btn-line'>
							<svg viewBox='0 0 24 24' className='h-4 w-4' aria-hidden='true'>
								<path fill='currentColor' d='M12 1.5a10.5 10.5 0 0 0-3.32 20.46c.53.1.72-.23.72-.5v-1.85c-2.92.63-3.54-1.25-3.54-1.25-.48-1.21-1.17-1.53-1.17-1.53-.95-.65.08-.64.08-.64 1.05.08 1.6 1.08 1.6 1.08.94 1.6 2.46 1.14 3.06.87.1-.68.37-1.14.66-1.4-2.33-.27-4.78-1.17-4.78-5.18 0-1.15.41-2.08 1.08-2.82-.11-.26-.47-1.33.1-2.77 0 0 .88-.28 2.89 1.08a10 10 0 0 1 5.26 0c2-1.36 2.88-1.08 2.88-1.08.58 1.44.22 2.51.11 2.77.67.74 1.08 1.67 1.08 2.82 0 4.02-2.46 4.9-4.8 5.16.38.33.72.97.72 1.96v2.9c0 .28.19.6.73.5A10.5 10.5 0 0 0 12 1.5Z' />
							</svg>
							GitHub
						</a>
					</p>
				</div>
			</div>
		</Sheet>
	);
}
